import { render, staticRenderFns } from "./ModuleName.vue?vue&type=template&id=3af12ccb&scoped=true&"
import script from "./ModuleName.vue?vue&type=script&lang=js&"
export * from "./ModuleName.vue?vue&type=script&lang=js&"
import style0 from "./ModuleName.vue?vue&type=style&index=0&id=3af12ccb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af12ccb",
  null
  
)

export default component.exports